module.exports = __webpack_public_path__ + "img/f4.07fd7d4e.png";